import { Button, Grid } from "@material-ui/core";
import { WHITE } from "../../utils/const";
import useCustomState from "../../hooks/State";
import DeviceEditModal from "./DeviceEditModal";
const DeviceSettings = ({ deviceInfo }) => {
  const styles = { container: { padding: "5px 15px", margin: "10px 0" } };
  const modalOpen = useCustomState(false);
  const modalContextType = useCustomState(1);
  const openModal = (type) => {
    modalContextType.handleChange(type);
    modalOpen.handleChange(true);
  };
  return (
    <>
      <DeviceEditModal
        open={modalOpen}
        info={deviceInfo}
        type={modalContextType.value}
      />
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        <Button
          variant="contained"
          color="primary"
          style={{ color: WHITE }}
          onClick={() => openModal(1)}
        >
          ویرایش دستگاه
        </Button>
        <Button
          variant="contained"
          color="secondary"
          style={{ color: WHITE, margin: "0 10px" }}
          onClick={() => openModal(2)}
        >
          ویرایش مشخصات نصب
        </Button>
      </Grid>
    </>
  );
};
export default DeviceSettings;
